export default "__VITE_ASSET__DaoAStMh__";